<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Raise a Help Desk Service Request</h4>
          </div>
          <div style="border-block: inherit;font-size: small;">
            <div style="margin-left: 15px;margin-top: 10px;">
              Please fill out the following information. Fields marked as <span
                style="color: red;font-weight: bold;">*</span> are mandatory. When finished, click the Submit button
              below.
            </div>
            <div style="margin-left: 15px;margin-bottom: 10px;margin-top: 5px;">
              NOTE: Your e-mail request may be monitored for Quality Assurance purposes.
            </div>
            <div style="float:left;margin-left: 15px;margin-top: 10px; margin-bottom: 10px;">
              <span style="display:inline;">
                Please download this help guide for reference:-
              </span>
              <span style="display:inline;"><u style="color: blue;"><a download="UserGuide.pdf" target="_blank"
                    type="file" href="/assets/HelpLink/UserGuide.pdf">Download
                    Help Link</a></u> </span>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="CreateServiceRequestForm" (ngSubmit)="SubmitRequest()">
              <div class="row">
                <div class="col-md-12">
                  <mat-checkbox class="example-margin" formControlName="IsRequestedFor"
                    [checked]="CreateServiceRequestForm.controls.IsRequestedFor.value"
                    (change)="ShowRequestedForControl($event.checked)">Submitting request for another user?
                  </mat-checkbox>

                </div>

              </div>
              <div class="row">
                <div class="col-md-12">


                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label
                        class="required"><span>Requester</span></label></div>
                    <div class="col-md-8">
                      <p-autoComplete formControlName="RequesterHead" [suggestions]="requesterList"
                        (completeMethod)="SearchActiveEmployee($event)" field="EmployeeName" [forceSelection]="true"
                        [minLength]="3" size="120" (onSelect)="SetEmployeeDetails($event)"
                        (onClear)="clearAutoComplete('RequesterHead')" [readonly]="true">
                      </p-autoComplete>
                      <mat-error
                        *ngIf="GetFormControls('RequesterHead').invalid && (GetFormControls('RequesterHead').dirty || GetFormControls('RequesterHead').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('RequesterHead').errors.required">
                          Requested By is required.
                        </mat-error>
                      </mat-error>

                    </div>
                  </div>
                </div>
                <div class="col-md-6">

                  <div class="row" *ngIf="IsVisisble">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="required">Requested for
                        <span style="color: red;font-weight: bold;">*</span></label></div>
                    <div class="col-md-8">
                      <p-autoComplete formControlName="RequestedforHead" [suggestions]="requesterList"
                        (completeMethod)="SearchActiveEmployee($event)" field="EmployeeName" [forceSelection]="true"
                        [minLength]="3" size="120" (onSelect)="SetRequesterforDetails($event)"
                        (onClear)="clearAutoComplete('RequesterForHead')">
                      </p-autoComplete>
                      <mat-error
                        *ngIf="GetFormControls('RequestedforHead').invalid && (GetFormControls('RequestedforHead').dirty || GetFormControls('RequestedforHead').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('RequestedforHead').errors.required">
                          Requested for is required.
                        </mat-error>
                      </mat-error>

                    </div>
                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 paddingforRightlabel"> <label style="display: none;">Requester phone</label>
                    </div>
                    <div class="col-md-8">
                      <input class="form-control" style="display: none;" placeholder="" [readonly]="true"
                        formControlName="RequesterCUG">
                      <!-- <mat-error style="display: none;"
                                *ngIf="GetFormControls('RequesterCUG').invalid && (GetFormControls('RequesterCUG').dirty || GetFormControls('RequesterCUG').touched)"
                                class="ValidationError">
                                <mat-error *ngIf="GetFormControls('RequesterCUG').errors.required">
                                 Requested By phone is required.
                                </mat-error> 
                              </mat-error>-->
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="required"
                        style="display: none;">Requested for phone </label></div>
                    <div class="col-md-8">
                      <input class="form-control" style="display: none;" [readonly]="true"
                        formControlName="RequestedForCUG">
                      <!-- <mat-error
                                    *ngIf="GetFormControls('RequestedForCUG').invalid && (GetFormControls('RequestedForCUG').dirty || GetFormControls('RequestedForCUG').touched)"
                                    class="ValidationError">
                                    <mat-error *ngIf="GetFormControls('RequestedForCUG').errors.required" style="display: none;">
                                     Requested for phone is required.
                                    </mat-error>
                                  </mat-error> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="clearfix" *ngIf="IsVisisble"></div> -->

              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label
                        class="required"><span>Location</span></label></div>
                    <div class="col-md-8">
                      <p-dropdown appendTo="body" [options]="locationList" [readonly]="true" placeholder="--Select--"
                        formControlName="ReqLocation" filter="true" class="w-100">
                      </p-dropdown>
                      <mat-error
                        *ngIf="GetFormControls('ReqLocation').invalid && (GetFormControls('ReqLocation').dirty || GetFormControls('ReqLocation').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('ReqLocation').errors.required">
                          Location is required.
                        </mat-error>
                      </mat-error>

                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="required">Category <span
                          style="color: red;font-weight: bold;">*</span></label></div>
                    <div class="col-md-8">
                      <!-- style="max-height: 200px;" -->
                      <p-dropdown appendTo="body" [options]="categoryList" placeholder="--Select--"
                        formControlName="CategoryID" filter="true" data-bs-toggle="tooltip" title="Add Category"
                        (onChange)="GetSubCategoryName($event)" [showClear]="true"appendTo="body">
                      </p-dropdown>
                      <mat-error
                        *ngIf="GetFormControls('CategoryID').invalid && (GetFormControls('CategoryID').dirty || GetFormControls('CategoryID').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('CategoryID').errors.required">
                          Category is required.
                        </mat-error>
                      </mat-error>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>

              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="required">Sub Category <span
                          style="color: red;font-weight: bold;">*</span></label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="subcategoryList" placeholder="--Select--" formControlName="SubCategoryID"
                        filter="true" (onChange)="GetItemName($event)" [showClear]="true" appendTo="body">
                      </p-dropdown>
                      <mat-error
                        *ngIf="GetFormControls('SubCategoryID').invalid && (GetFormControls('SubCategoryID').dirty || GetFormControls('SubCategoryID').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('SubCategoryID').errors.required">
                          Sub Category is required.
                        </mat-error>
                      </mat-error>

                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label paddingforRightlabel"> <label class="required">Items <span
                          style="color: red;font-weight: bold;">*</span></label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="itemList" placeholder="--Select--" formControlName="ItemID" filter="true"
                       appendTo="body"
                        [showClear]="true">
                      </p-dropdown>
                      <mat-error
                        *ngIf="GetFormControls('ItemID').invalid && (GetFormControls('ItemID').dirty || GetFormControls('ItemID').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('ItemID').errors.required">
                          Item is required.
                        </mat-error>
                      </mat-error>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>




              <div class="row">
                <div class="col-md-12 paddingforRightlabel">
                  <label class="required">What is your question or issue? <span
                      style="color: red;font-weight: bold;">*</span> Character Limit is 250</label>
                  <!--Characters Remaining: {{GetFormControls(ShortDescription).length}}/{{ShortmaxChars}}</span></label> -->
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <input class="form-control" style="margin-left: 10px;width: 99%;" formControlName="ShortDescription"
                    maxlength="250">
                  <mat-error
                    *ngIf="GetFormControls('ShortDescription').invalid && (GetFormControls('ShortDescription').dirty || GetFormControls('ShortDescription').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('ShortDescription').errors.required">
                      Question is required.
                    </mat-error>
                  </mat-error>
                  <span style="color: red;font-size: 10px;margin-left: 11px;"> Note: EY does not intentionally collect
                    any sensitive personal data from you via the Tool. The Tool’s intention is not to process such
                    information.
                  </span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-12 paddingforRightlabel">
                  <label class="required">Please provide details in the box below. Please use Add Attachments link at
                    the bottom of page to include screen shots.<i
                      class="fa fa-question-circle padder-xs help-tag-icon ng-scope"
                      title="More information for Please provide details in the box below. Please use Add Attachments link at the bottom of page to include screen shots."
                      tabindex="0" style="font-size:16px;"></i></label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <textarea class="form-control" style="margin-left: 10px;width: 99%;" formControlName="LongDescription"
                    maxlength="1500"></textarea>
                  <!-- <mat-error
                                *ngIf="GetFormControls('LongDescription').invalid && (GetFormControls('LongDescription').dirty || GetFormControls('LongDescription').touched)"
                                class="ValidationError">
                                <mat-error *ngIf="GetFormControls('LongDescription').errors.required">
                                Detail is required.
                                </mat-error>
                              </mat-error> -->
                  <span style="color: red;font-size: 10px;margin-left: 11px;"> Note: EY does not intentionally collect
                    any sensitive personal data from you via the Tool. The Tool’s intention is not to process such
                    information.
                  </span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="form-group col-md-3 paddingforRightlabel">

                  <div class="input-group">
                    <!-- <input class="form-control" type="file" style="Padding:8px; background-color: #d6cdcd40;"
                                   
                                    accept=".xlsx,.pdf,.doc,.xls,.docx,.zip,.jpeg,.jpg,.png,.msg,.eml" /> -->
                    <span style="color: red;font-size: small;">Max size should not exceed 10 MB </span>
                    <i class="fa fa-paperclip" style="font-size:14px; cursor: pointer" (click)="fileInput.click()">
                      <span>Add Attachment</span>
                      <input #fileInput type="file" (change)="UploadAttachment($event)" style="display:none;" />
                    </i>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <table>
                    <tr *ngFor='let url of attachmentList' class="urlSet">
                      <td style="padding: 5px;">
                        <div style="float: left;">
                          <a style="cursor:pointer;" (click)="DownLoadFile(url)">{{url.AttachmentName}}</a>
                        </div>
                        <div style="float: left;margin-left: 10px;">
                          <i class="fa fa-trash" style="font-size:18px; color:red; cursor: pointer"
                            (click)="DeleteAttachment(url.AttachmentName)"></i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" style="text-align: right !important;">
                  <button type="submit" class="btn-primary1">Submit</button>

                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>